import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Inquire from "@/pages/Inquire";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import Admin from "@/pages/Admin";
import { About, Solutions, Products, Network, Work, Sustainability, Insights } from "@/pages/Pages";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Shell = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/about" element={<Shell><About /></Shell>} />
          <Route path="/solutions" element={<Shell><Solutions /></Shell>} />
          <Route path="/products" element={<Shell><Products /></Shell>} />
          <Route path="/network" element={<Shell><Network /></Shell>} />
          <Route path="/work" element={<Shell><Work /></Shell>} />
          <Route path="/sustainability" element={<Shell><Sustainability /></Shell>} />
          <Route path="/insights" element={<Shell><Insights /></Shell>} />
          <Route path="/contact" element={<Shell><Contact /></Shell>} />
          <Route path="/inquire" element={<Shell><Inquire /></Shell>} />
          <Route path="/thank-you" element={<Shell><ThankYou /></Shell>} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
